import { Redirect, Route } from 'react-router';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { HeaderTabsState } from '../HeaderTabs';
import { CareMapState } from '../caremap/CareMapState';
import { CommunityRouteHandler } from '../community/CommunityRouteHandler';
import { ResourcesRouteHandler } from '../resources/ResourcesRouteHandler';

export const CommunityRouter: React.FC = () => {

    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    const tabsState = useInstance(HeaderTabsState);
    useSubscription(() => tabsState);

    return (
        <>
            <Route path="/community-redirect" exact render={() => {
                const lastTab = tabsState.getLastActiveTab('community-tabs');
                const careMap = careMapState.getMostRecentCaremap();
                let redirectTo: string;
                if (lastTab?.dataId === 'resources-tab') {
                    redirectTo = '/resources';
                } else {
                    redirectTo = `/community/${careMap?.careMapId}`;
                }
                return (
                    <Redirect to={redirectTo} />
                );
            }} />

            <CommunityRouteHandler />
            <ResourcesRouteHandler />
        </>
    );
};
